import { useQuery } from '@tanstack/react-query';
import * as api from './api';

const ROOT_KEY = 'districts';

export function useDistrictOptions() {
  return useQuery({
    queryKey: [ROOT_KEY, 'options'] as const,
    queryFn: () => api.getDistrictOptions(),
    staleTime: 60 * 60 * 1000,
  });
}
